import { interiorPreviewSchema } from "../schemas";
import {
  makeAnyKeySelector,
  makeCollectionSelector,
  makeAnyKeyCollectionSelector,
  makeFetchStatusSelector,
} from "./collections";

export const DEFAULT_COLLECTION = "index";

export function makeViewAnyKeySelector(key, collection) {
  return makeAnyKeySelector(key, collection, interiorPreviewSchema);
}

export function makeInteriorPreviewsSelector(collection = DEFAULT_COLLECTION) {
  return makeCollectionSelector(collection, interiorPreviewSchema);
}

export function makeInteriorPreviewsAnyKeySelector(key, collection = DEFAULT_COLLECTION) {
  return makeAnyKeyCollectionSelector(key, collection, interiorPreviewSchema);
}

export function makeInteriorPreviewsFetchStatusSelector(collection = DEFAULT_COLLECTION) {
  return makeFetchStatusSelector(collection, interiorPreviewSchema);
}